<h1 mat-dialog-title>{{ 'executionEdit.validation.title' | translate }}</h1>
<form [formGroup]="mainForm">

  <div mat-dialog-content class="qualificates-theme" style="min-height: 10vh;">

    @if (showReason()) {
      <div>
        <p> {{ 'executionEditQ.result.validation.confirmSave.reason.label' | translate }} </p>
        <mat-form-field class="campoFormulario" style="width: 100%">
          <mat-label>{{ 'executionEditQ.result.validation.confirmSave.reason.label' | translate }}</mat-label>
          <textarea rows="5" matAutosizeMinRows="5" matInput [(ngModel)]="reason" formControlName="reason" required
          [errorStateMatcher]="matcher" style="resize: none;" [ngModelOptions]="{standalone: true}"></textarea>
          <mat-error>
            {{ 'executionEditQ.result.validation.confirmSave.reason.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    @if (!isEmpty(warns)) {
      <div>
        <p> {{ 'executionEditQ.result.validation.according_conditioned' | translate }} </p>
      </div>
    }

    @if (!isEmpty(errors)) {
      <div>
        <p> {{ 'executionEditQ.result.validation.invalid' | translate }} </p>
        <mat-radio-group [(ngModel)]="forceAccording" formControlName="forceAccording"
          [ngModelOptions]="{standalone: true}">
          <mat-radio-button [value]="false">{{'executionEditQ.result.validation.invalid.yes' | translate}}</mat-radio-button>
          <br />
          <mat-radio-button [value]="true">{{'executionEditQ.result.validation.invalid.no' | translate}}</mat-radio-button>
        </mat-radio-group>
        @if (forceAccording == false) {
          <mat-form-field class="campoFormulario" style="width: 100%">
            <mat-label>{{ 'common.reason' | translate }}</mat-label>
            <textarea rows="5" matAutosizeMinRows="5" matInput
              [(ngModel)]="reasonForce" formControlName="reasonForce" required [errorStateMatcher]="matcher"
            style="resize: none;" [ngModelOptions]="{standalone: true}"></textarea>
          </mat-form-field>
        }
      </div>
    }

    @if (isEmpty(errors) && isEmpty(warns)) {
      <div>
        <p> {{ 'executionEditQ.result.validation.valid' | translate }} </p>
      </div>
    }
  </div>

  <div mat-dialog-actions class="thermal-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" [disabled]="!canAccept()" cdkFocusInitial>{{ 'button.accept' | translate }}</button>


    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>